"use client";

import React from 'react';
import Link from 'next/link';
import ImageWrapper from './ImageWrapper';

interface NewsListItemProps {
    news: {
        _id: string;
        title: string;
        slug: string;
        published_at?: string;
        createdAt?: string;
        image?: string;
    };
    isLast?: boolean;
    priority?: boolean;
}
const NewsListItem: React.FC<NewsListItemProps> = ({ news, isLast = false, priority = true }) => {
    const formatDate = (dateString: string) => {
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch {
            return dateString;
        }
    };

    const getDisplayDate = () => {
        // Always show createdAt, even if news is updated
        return news.createdAt || '';
    };

  
    return (
        <Link href={`/news/${news.slug}`} prefetch={false} title={news.title}>
            <div className={`flex gap-3 py-3 hover:bg-gray-50 transition-colors ${!isLast ? 'border-b border-gray-200' : ''}`}>
                <div className="relative w-29 h-16 flex-shrink-0 rounded overflow-hidden bg-gray-200">
                    <ImageWrapper
                        src={news.image}
                        alt={news.title}
                        className="object-cover"
                        loading="lazy"
                        title={news.title}
                        width={116}
                        height={64}
                        priority={priority}
                    />
                </div>
                <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-gray-900 line-clamp-2 mb-1">
                        {news.title}
                    </h3>
                    <p className="text-xs text-gray-500">
                        {formatDate(getDisplayDate())}
                    </p>
                </div>
            </div>
        </Link>
    );
};

export default NewsListItem;
